import React from 'react'
import {connect} from 'react-redux'
import {List, fromJS} from 'immutable'

import {
  CONVERSATION_PANE_STATUSES
} from '../shared/config/constants'

import ConversationDirector from './conversation_director'

class ConversationsStack extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      stack: fromJS([])
    }
  }

  componentWillMount () {
    this.setStack(this.props.stack)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.stack !== nextProps.stack) {
      this.setStack(nextProps.stack)
    }
  }

  setStack (stack) {
    this.setState({stack})
  }

  renderConversation (conv, index) {
    return (
      <ConversationDirector
        key={conv.get('conversationId')}
        index={index}
        conversation={conv}/>
    )
  }

  renderConversationStack () {
    return this.state.stack.map(this.renderConversation)
  }

  renderConversationStackForPhone () {
    const conv = this.state.stack.find((c) => c.get('status') === CONVERSATION_PANE_STATUSES.OPEN)

    if (!conv) return false

    return this.renderConversation(conv, 0)
  }

  render () {
    if (this.props.phoneView) return this.renderConversationStackForPhone()

    return (
      <div className='conversations-stack'>
        {this.renderConversationStack()}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stack: state.getIn(['conversations', '_stack', 'visibles'], List())
  }
}

const mapDispatchToProps = () => {
  return {}
}

const ConversationsStackContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ConversationsStack)

export default ConversationsStackContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversations_stack.js
 **/